import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  NavbarBrand,
  Dropdown,
  Modal,
  Spinner,
  Offcanvas,
} from "react-bootstrap";
import DownloadSvg from "../svgs/DownloadSvg";
import LogoutComponent from "./LogoutComponent";
import ThyrocareIcon from "../svgs/ThyrocareIcon";
import UserSvg from "../svgs/UserSvg";
import "../css/navbarCss.css";
import NiroggyanSvg from "../svgs/NiroggyanSvg";
import axios from "axios";
import { orgCenterData } from "../specs/orgCenterData";
import { Button, FormControl } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import ExploreIcon from "@mui/icons-material/Explore";
import NotificationsIcon from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemText from "@mui/material/ListItemText";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import FeedbackIcon from "@mui/icons-material/Feedback";
import Feedback from "./Feedback";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArticleIcon from "@mui/icons-material/Article";
import ComputerIcon from "@mui/icons-material/Computer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import RedeemIcon from "@mui/icons-material/Redeem";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { RiEditBoxFill } from "react-icons/ri";
import { SiGoogleanalytics } from "react-icons/si";
import { useAlert } from "react-alert";
import RestoreIcon from "@mui/icons-material/Restore";
import { ssoLogout } from "../auth/checkClientAuth";

//import EditIcon from "@mui/icons-material/Edit";

const NavbarComponent = ({ setNavBarTrigerred }) => {
  const [loginData, setLoginData] = useState("");
  const [reRenderComponent, setReRenderComponent] = useState(false);
  const [loadingCenterData, setLoadingCenterData] = useState(false);
  const [orgAndCentersData, setOrgAndCentersData] = useState([]);
  const [selectionBasedCenters, setSelectionBasedCenters] = useState([]);
  const [orgChoosen, setOrgChoosen] = useState("");
  const [centerChoosen, setCenterChoosen] = useState("");
  const [typeOfNewClient, setTypeOfNewClient] = useState("");

  // Move these before activeTab so we can read location.pathname for the initial value
  const navigate = useNavigate();
  const location = useLocation();
  const alert = useAlert();

  // Derive the correct active tab from pathname upfront — avoids the one-frame
  // flash to "Subscription" that happened when NavbarComponent remounted on navigation.
  const [activeTab, setActiveTab] = useState(() => {
    const p = location.pathname;
    if (p === "/" || p === "/subscription") return "Subscription";
    if (p === "/analytics") return "Analytics";
    if (p === "/support") return "Technical Support";
    if (p === "/client-data") return "Edit Subscription";
    if (p === "/manualReports" || p.startsWith("/manualReports/")) return "Manual Generation";
    if (p === "/refer") return "Refer";
    if (p === "/user-activity") return "User Activity";
    if (p.startsWith("/configurations")) return "Configurations";
    return "Choose Org & Center";
  });
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem("sidebarExpanded");
    return saved ? JSON.parse(saved) : false;
  });

  console.log("loginData", loginData);

  // modal state and functions
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // modal state and functions
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  //notification modal state & functions
  const [showNotification, setShowNotification] = useState(false);
  const handleNoficationOpen = () => setShowNotification(true);
  const handleNoficationClose = () => setShowNotification(false);

  // feedbackmodal
  const [showFeedback, setShowFeedback] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // maintenance page
  const [maintenance, setMaintenance] = useState(false);

  window.addEventListener("storage", (e) => {
    // console.log("something got changed.")
    setReRenderComponent(!reRenderComponent);
  });

  let logoToUse =
    localStorage.getItem("logoUrl") === "undefined"
      ? "https://res.cloudinary.com/nithish0504/image/upload/v1652856436/niroggyan-logo_pc2fef.svg"
      : JSON.parse(localStorage.getItem("logoUrl"));

  // let loginStatus = JSON.parse(localStorage.getItem("loginDetails"))

  // console.log("loginStatus\n", loginStatus)

  useEffect(() => {
    const loginInfo = JSON.parse(localStorage.getItem("loginDetails"));
    const maintenance = JSON.parse(localStorage.getItem("maintenance"));
    setMaintenance(maintenance);

    if (loginInfo) {
      setLoginData(loginInfo);
    }
  }, [reRenderComponent]);

  // getting orgs and centres
  useEffect(() => {
    const loginInfo = JSON.parse(localStorage.getItem("loginDetails"));
    let allData = [];
    if (loginInfo) {
      // for (const property in orgCenterData) {
      //   // console.log(`=> ${property}: ${orgCenterData[property]}`);
      //   let theKeyAndValue = `${property}: ${orgCenterData[property]}`;
      //   allData.push({ theOrg: property, theCenters: orgCenterData[property] });
      // }
      let data = [];
      let Data = {};
      for (let index in loginInfo.clientData) {
        if (loginInfo.clientData[index].org in Data) {
          Data[loginInfo.clientData[index].org].theCenters.push(
            loginInfo.clientData[index].center
          );
        } else {
          Data[loginInfo.clientData[index].org] = {
            theOrg: loginInfo.clientData[index].org,
            theCenters: [loginInfo.clientData[index].center],
          };
        }
      }
      for (let each in Data) {
        data.push(Data[each]);
      }
      console.log("loginInfo.clientData", loginInfo.clientData);
      // console.log(allData);
      // console.log(data);
      setOrgAndCentersData(data);
    }
  }, [reRenderComponent]);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
      case "/subscription":
        setActiveTab("Subscription");
        break;
      case "/analytics":
        setActiveTab("Analytics");
        break;
      case "/support":
        setActiveTab("Technical Support");
        break;
      case "/client-data":
        setActiveTab("Edit Subscription");
        break;
      case "/manualReports":
        setActiveTab("Manual Generation");
        break;
      case "/refer":
        setActiveTab("Refer");
        break;
      case "/configurations":
      case "/configurations/mapping":
      case "/configurations/product-config":
      case "/configurations/content-management":
        setActiveTab("Configurations");
        break;
      case "/user-activity":
        setActiveTab("User Activity");
        break;
      default:
        if (location.pathname.startsWith("/manualReports/")) {
          setActiveTab("Manual Generation");
        } else if (location.pathname.startsWith("/configurations")) {
          setActiveTab("Configurations");
        } else {
          setActiveTab("Choose Org & Center");
        }
    }
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem("sidebarExpanded", JSON.stringify(isExpanded));
  }, [isExpanded]);

  // auto logout on session expiry

  useEffect(() => {
    const startTime = new Date(
      parseInt(localStorage.getItem("sessionStartTime"))
    );
    const timeLeft = startTime - new Date().getTime();

    console.log("timeLeft", startTime, timeLeft);

    if (timeLeft <= 0) {
      logoutHandler();
    } else {
      const timeId = setTimeout(() => {
        logoutHandler();
      }, timeLeft);
      return () => clearTimeout(timeId);
    }
  }, []);

  const feedbackFlag = localStorage.getItem("feedbackShown");

  // feedback popup — triggered by custom event fired when user scrolls to feedback section
  useEffect(() => {
    const handler = () => {
      setShowFeedback(true);
      localStorage.setItem("feedbackShown", "true");
    };
    window.addEventListener("showFeedbackPopup", handler);
    return () => window.removeEventListener("showFeedbackPopup", handler);
  }, []);

  const getCenterData = async (theId) => {
    console.log("getting center data", theId);
    handleShow();

    let endpointToUse;

    if (theId === "trial") {
      endpointToUse = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/counts/?org=${
        loginData ? loginData.org : ""
      }&center=trial`;
    } else {
      endpointToUse = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${
        loginData ? loginData.org : ""
      }&center=${theId}`;
    }

    var config = {
      method: "GET",
      //url: '',
      url: endpointToUse,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      if (theId === "trial") {
        const axiosData = await axios(config);
        console.log(`center and org data\n`, axiosData);
        localStorage.setItem("trialClientsData", JSON.stringify(axiosData));
        localStorage.setItem("trialClientPreference", JSON.stringify("yes"));
        window.dispatchEvent(new Event("storage"));
        setReRenderComponent(!reRenderComponent);
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        // EXPIRING LOGIN SESSION
        // var datetime = new Date().toLocaleString().replace(',', '')

        const axiosData = await axios(config);
        //console.log(`center data of ${theId}\n`, axiosData)
        localStorage.setItem(
          "homepageData",
          JSON.stringify({ data: axiosData.data })
        );
        localStorage.setItem("clientPreference", JSON.stringify(theId));
        setReRenderComponent(!reRenderComponent);
        window.dispatchEvent(new Event("storage"));
        setTimeout(() => {
          handleClose();
        }, 1500);
        //window.location.reload()
        // localStorage.setItem("centerDetails", JSON.stringify(axiosData.data))
      }
    } catch (error) {
      setTimeout(() => {
        handleClose();
      }, 1500);
      console.log("Center Endpoint Error:\n", error);
    }
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      style={{ textDecoration: "none", color: "inherit" }}
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      &#x25bc;
    </a>
  ));

  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
      const [value, setValue] = useState("");

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <FormControl
            autoFocus
            className="mx-3 my-2 w-auto"
            placeholder="search org"
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
          <ul className="list-unstyled">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value)
            )}
          </ul>
        </div>
      );
    }
  );

  const CustomMenu2 = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
      const [value, setValue] = useState("");

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <FormControl
            autoFocus
            className="mx-3 my-2 w-auto"
            placeholder="search center"
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
          <ul className="list-unstyled">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value)
            )}
          </ul>
        </div>
      );
    }
  );

  const chooseCenterHandler = (theData) => {
    console.log("chooseCenterHandler have:", theData.theOrg);
    setOrgChoosen(theData.theOrg);
    setSelectionBasedCenters(theData.theCenters);
  };

  const customOrgAndCenterApiHandler = async () => {
    handleClose2();
    handleShow();

    let endpointToConsider;

    if (centerChoosen === "trial") {
      endpointToConsider = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/counts/?org=${orgChoosen}&center=trial`;
    } else {
      endpointToConsider = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${orgChoosen}&center=${centerChoosen}`;
    }

    console.log("the center and org endpoint\n", endpointToConsider);

    var config = {
      method: "GET",
      //url: '',
      url: endpointToConsider,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      if (centerChoosen === "trial") {
        const axiosData = await axios(config);
        console.log(`center and org data\n`, axiosData);
        localStorage.setItem("trialClientsData", JSON.stringify(axiosData));
        localStorage.setItem("trialClientPreference", JSON.stringify("yes"));
        window.dispatchEvent(new Event("storage"));
        setReRenderComponent(!reRenderComponent);
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        // const axiosData = await axios(config);
        // console.log(`center and org data\n`, axiosData);
        // localStorage.setItem(
        //   'homepageData',
        //   JSON.stringify({ data: axiosData.data })
        // );
        localStorage.setItem("clientPreference", JSON.stringify(centerChoosen));
        localStorage.setItem("orgPreference", JSON.stringify(orgChoosen));
        // set clientId of the center selected
        const loginInfo = JSON.parse(localStorage.getItem("loginDetails"));
        const clientId = loginInfo.clientData.filter(
          (each) => each.org === orgChoosen
        )[0].clientId;

        localStorage.setItem("clientIdPreference", JSON.stringify(clientId));
        window.dispatchEvent(new Event("storage"));
        setReRenderComponent(!reRenderComponent);
        window.location.replace("/subscription");
        setTimeout(() => {
          handleClose();

          window.location.reload();
        }, 1500);
        //window.location.reload()
        // localStorage.setItem("centerDetails", JSON.stringify(axiosData.data))
      }
    } catch (error) {
      setTimeout(() => {
        handleClose();
      }, 1500);
      console.log("Center Endpoint Error:\n", error);
    }
  };

  const handleNewClients = (clientRecieved) => {
    setTypeOfNewClient(clientRecieved);
    handleClose2();
    window.open(`/new-client/${clientRecieved}`, "_self");
  };


  const drawerWidth = 240;

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const logoutHandler = async () => {
    localStorage.clear();
    localStorage.setItem("myLoginDetails", JSON.stringify(""));
    localStorage.setItem("clientPreference", JSON.stringify("none"));
    localStorage.setItem(
      "logoUrl",
      JSON.stringify(
        "https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"
      )
    );
    window.dispatchEvent(new Event("storage"));
    await ssoLogout();
  };

  const handleNavigation = (text) => {
    console.log("selectedText", text);
    localStorage.setItem("selectedTab", text);

    switch (text) {
      case "Subscription":
        navigate("/subscription");
        break;
      case "Analytics":
        navigate("/analytics");
        break;
      case "Edit Subscription":
        navigate("/client-data");
        break;
      case "Choose Org & Center":
        handleShow2();
        break;
      case "Technical Support":
        navigate("/support");
        break;
      case "Logout":
        logoutHandler();
        break;
      case "Manual Generation":
        navigate("/manualReports");
        break;
      case "Refer":
        navigate("/refer");
      case "Configurations":
        navigate("/configurations");
        break;
      case "User Activity":
        navigate("/user-activity");
        break;
    }
  };


  const adminAndLisData = () => {
    return (
      <>
        {/* Modal Start (for loading center data) */}
        <div>
          <>
            <Modal show={show} onHide={handleClose} backdrop="static" centered>
              <Modal.Body style={{ textAlign: "center" }}>
                <Spinner animation="border" size="sm" /> Loading Data ...
              </Modal.Body>
            </Modal>
          </>
        </div>

        {/* Modal End */}

        {/* Modal Start (for dynamic org and center) */}
        <div>
          <>
            <Modal
              show={show2}
              onHide={handleClose2}
              dialogClassName="custom-modal"
              style={{ top: "80px" }}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  style={{ color: "#190e6c", display: "flex", gap: "12px" }}
                >
                  <div>{"ORG & CENTER"}</div>

                  <div>
                    <Dropdown style={{ position: "relative", top: "-3px" }}>
                      <Dropdown.Toggle
                        variant="info btn-sm"
                        id="dropdown-basic"
                        style={{ fontWeight: "bold" }}
                      >
                        New Client
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleNewClients("lab")}>
                          Add LAB
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleNewClients("lis")}>
                          Add LIS
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleNewClients("admin")}
                        >
                          Add ADMIN
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {/* <button
                                  style={{ marginLeft: "10px", fontWeight: "bold", position: "relative", top: "-3px" }}
                                  className='btn btn-sm btn-info'
                                  onClick={() => window.open("/new-client/", "_self")}
                              >
                                  {"New"} <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                              </button> */}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                {/* Choose Org Dropdown Start */}
                <Dropdown>
                  <Dropdown.Toggle
                    as={CustomToggle}
                    id="dropdown-custom-components"
                  >
                    {"Choose Org "}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    as={CustomMenu}
                    style={{ overflow: "scroll", height: "300px" }}
                  >
                    {orgAndCentersData.map((each, idx) => (
                      <Dropdown.Item
                        eventKey={idx}
                        onClick={() => chooseCenterHandler(each)}
                      >
                        {each.theOrg}
                      </Dropdown.Item>
                    ))}
                    {/* <Dropdown.Item eventKey="3" active>
                                      Orange
                                  </Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>

                {/* Choose Org Dropdown End*/}

                {/* Choose Center Dropdown Start */}
                {orgChoosen === "" ? (
                  <span style={{ color: "grey" }}>{"Choose Center"}</span>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      id="dropdown-custom-components"
                    >
                      {"Choose Center "}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      as={CustomMenu2}
                      style={{ overflow: "scroll", height: "300px" }}
                    >
                      {selectionBasedCenters.map((each, idx) => (
                        <Dropdown.Item
                          eventKey={idx}
                          onClick={() => setCenterChoosen(each)}
                        >
                          {each}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
                {/* Choose Center Dropdown End */}
              </Modal.Body>

              <Modal.Body style={{ fontSize: "14px" }}>
                <span style={{ fontWeight: "550" }}>{"Org: "}</span>
                <span style={{ color: "#7787bc" }}>{orgChoosen}</span>
                {" | "}
                <span style={{ fontWeight: "550" }}>{"Center: "}</span>
                <span style={{ color: "#7787bc" }}>{centerChoosen}</span>
              </Modal.Body>
              <Modal.Footer
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <a href="/subscription">
                  <Button
                    disabled
                    onClick={() =>
                      localStorage.setItem(
                        "choosenClient",
                        JSON.stringify({
                          org: orgChoosen,
                          center: centerChoosen,
                        })
                      )
                    }
                    variant="outline-success btn-sm d-none"
                  >
                    {"Edit Subscription"}
                  </Button>
                </a>

                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    variant="info btn-sm"
                    onClick={customOrgAndCenterApiHandler}
                  >
                    Fetch Info
                  </Button>
                  <Button variant="primary btn-sm" onClick={handleClose2}>
                    Cancel
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </>
        </div>

        {/* Modal End */}

        <>
          <div
            style={{
              alignItems: "center",
              justifyContent: "space-between",
              // paddingTop: "10px",
            }}
            className="d-flex"
          >
            {/* <UserSvg /> */}
            <div
              className="mx-3"
              style={{
                display: loginData && loginData.role === "LIS" ? "" : "none",
              }}
            >
              {/* <DownloadSvg /> */}
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  className="dropdownCss"
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "#ecedef",
                    borderRadius: "20px",
                  }}
                >
                  {"Choose Clients"}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ textAlign: "center" }}>
                  {loginData && loginData.role === "LIS"
                    ? loginData.liveClients.map((each, idx) => (
                        <Dropdown.Item
                          key={idx}
                          onClick={() => getCenterData(each)}
                        >
                          <span>{each}</span>
                        </Dropdown.Item>
                      ))
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div
              className="align-item-center"
              style={{
                marginTop: "0px",
                marginRight: "16px",
                display:
                  loginData && loginData.role === "admin" ? "flex" : "none",
                alignItems: "center",
              }}
            >
              {/* <DownloadSvg /> */}
              {/* <a href="/client-data">
                <Button variant="outline-light btn-sm mx-2">
                  {"Edit Subscription"}
                </Button>
              </a> */}
              {/* <div
                onClick={handleShow2}
                className="dropdownCss"
                id="dropdown-basic"
                style={{
                  position: "relative",
                  // top: '8px',
                  cursor: "pointer",
                  backgroundColor: "trasparent",
                  border: "1px solid #ffffff",
                  // borderRadius: "20px",
                  // padding: "10px",
                }}
              >
                {"Choose Org & Center"}
              </div> */}
              {/* <Button variant="outline-light btn-sm mx-2" onClick={handleShow2}>
                {"Choose Org & Center"}
              </Button> */}
            </div>
          </div>
        </>
      </>
    );
  };

  const notificationModal = () => {
    return (
      <Dialog
        open={showNotification}
        onClose={handleNoficationOpen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">Notifications</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Here are your recent notifications
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button onClick={handleNoficationClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const sideBarClientData1 = {
    Subscription: <HomeIcon />,
    Analytics: <ExploreIcon />,
  };

  const sideBarClientData2 = {
    Notification: <NotificationsIcon />,
    "Technical Support": <HelpIcon />,
    // "Business Query": <SupportAgentIcon />,
    Logout: <LogoutComponent />,
  };

  const sideBarAdminData1 = {
    Subscription: <HomeIcon />,
    "Edit Subscription": <EditIcon />,
    "Choose Org & Center": <GroupsIcon />,
  };

  const sideBarAdminData2 = {
    "Technical Support": <HelpIcon />,
    Logout: <LogoutComponent />,
  };

  const sideBarData1 =
    loginData && loginData.role === "lab"
      ? sideBarClientData1
      : sideBarAdminData1;

  const sideBarData2 =
    loginData && loginData.role === "lab"
      ? sideBarClientData2
      : sideBarAdminData2;

  const sideNavBar = () => {
    return (
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          open={open}
          sx={{
            background:
              loginData && loginData.role === "lab"
                ? "linear-gradient(to right, #1976d2 calc(100% - 200px), #ffffff 200px)"
                : "",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              {/* <Typography variant="h6" noWrap component="div">
                Client Dashboard
              </Typography> */}
              <Stack
                direction="row"
                alignItems="center"
                gap={7}
                alignSelf="flex-end"
              >
                <Box>{adminAndLisData()}</Box>
                {loginData && loginData.role === "lab" ? (
                  <IconButton onClick={handleNoficationOpen}>
                    <NotificationsIcon
                      sx={{ color: "#fff", position: "relative" }}
                    />
                    <Box
                      sx={{
                        width: "10px",
                        height: "10px",
                        display: "inline-block",
                        background: "red",
                        position: "absolute",
                        borderRadius: "50%",
                        top: "4px",
                        right: "4px",
                      }}
                    ></Box>
                  </IconButton>
                ) : (
                  ""
                )}
                {notificationModal()}
                {/* <Typography px={2}>
                  {loginData && loginData.displayName}
                </Typography> */}
                {loginData && loginData.role === "lab" ? (
                  <img
                    src={loginData.logoSrc}
                    alt={loginData.center}
                    height="50px"
                    width="150px"
                    style={{ objectFit: "contain", mixBlendMode: "multiply" }}
                  />
                ) : (
                  ""
                )}
              </Stack>
            </Stack>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            <Stack direction="row">
              <img
                alt="niroggyan_logo"
                src="https://niroggyan.s3.ap-south-1.amazonaws.com/websitelogos/Niroggyan_logo.svg"
              />
            </Stack>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <Stack justifyContent="space-between" sx={{ height: "100vh" }}>
            <List>
              {Object.keys(sideBarData1).map((text) => (
                <ListItem key={text} disablePadding sx={{ display: "block" }}>
                  <Tooltip title={text} placement="right">
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                      onClick={() => handleNavigation(text)}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {sideBarData1[text]}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              ))}
            </List>
            <List>
              {Object.keys(sideBarData2).map((text) => (
                <ListItem key={text} disablePadding sx={{ display: "block" }}>
                  <Tooltip title={text} placement="right">
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                      onClick={() => handleNavigation(text)}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {/* {index === 0 ? (
                          <NotificationsIcon />
                        ) : index === 1 ? (
                          <HelpIcon />
                        ) : index === 2 ? (
                          <SupportAgentIcon />
                        ) : (
                          <LogoutComponent />
                        )} */}
                        {sideBarData2[text]}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              ))}
            </List>
          </Stack>
        </Drawer>
      </Box>
    );
  };

  const newMenuBar = () => {
    const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
    const sideBarClientData = {
      Subscription: <HomeIcon />,
      Analytics: <SiGoogleanalytics size={20} />, // <MenuBookOutlinedIcon />
      "Manual Generation": <ArticleIcon />,
      "Technical Support": <PersonIcon />,
      Configurations: <RiEditBoxFill size={20} />,
      // "User Activity": <RestoreIcon />,
      // Refer: <RedeemIcon />,
    };

    const sideBarAdminData = {
      Subscription: <HomeIcon />,
      "Edit Subscription": <EditIcon />,
      "Choose Org & Center": <GroupsIcon />,
      "Manual Generation": <ArticleIcon />,
      "Technical Support": <PersonIcon />,
      "User Activity": <RestoreIcon />,
    };

    const sideBarData =
      loginDetails && loginDetails.role === "admin"
        ? sideBarAdminData
        : sideBarClientData;

    const logoutData = {
      // Refer: <RedeemIcon />,
      // Logout: <LogoutIcon />,
    };

    const manualEntryData = {
      "Manual Generation": <ArticleIcon />,
    };

    const handleScroll = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const currentDate = new Date();
    const prevDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      1
    );

    const currentMonth = `${
      month[currentDate.getMonth()]
    }-${currentDate.getFullYear()}`;
    const prevMonth = `${month[prevDate.getMonth()]}-${prevDate.getFullYear()}`;

    const dateStamp = () => {
      return (
        <Box
          sx={{
            display: isExpanded ? "block" : "none",
            mt: 2,
            background: "rgba(255,255,255,0.05)",
            borderRadius: "10px",
            p: "12px 14px",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          {[
            { label: "This Month", value: currentMonth },
            { label: "Prev Month", value: prevMonth },
            { label: "Today", value: new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) },
          ].map(({ label, value }) => (
            <Stack key={label} direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
              <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.48)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px" }}>
                {label}
              </Typography>
              <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.85)", fontWeight: 600 }}>
                {value}
              </Typography>
            </Stack>
          ))}
        </Box>
      );
    };

    return (
      <Box
        px={2}
        py={3}
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          height: "100vh",
          width: isExpanded ? { xs: "246px", sm: "260px" } : "72px",
          background: "linear-gradient(180deg, #14095d 0%, #170C6B 52%, #1b1080 100%)",
          overflowY: "auto",
          overflowX: "hidden",
          flexShrink: 0,
          boxSizing: "border-box",
          transition: "width 0.3s ease",
          borderRight: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Stack sx={{ height: "100%" }}>
          <Box flexGrow={1}>
            <Box
              sx={{
                textAlign: "center",
                borderBottom: "1px solid rgba(255,255,255,0.12)",
                display: "flex",
                alignItems: "center",
              }}
              ml={1}
              mr={1}
              pb={3}
            >
              <IconButton
                onClick={() => {
                  setIsExpanded(!isExpanded);
                  // handleNavbarToggle();
                  setNavBarTrigerred((prev) => !prev);
                }}
                sx={{ marginRight: "10px", color: "#fff" }}
              >
                <MenuIcon />
              </IconButton>
              <Box sx={{ display: isExpanded ? "" : "none" }}>
                <img
                  alt="niroggyan_logo"
                  src="https://niroggyan.s3.ap-south-1.amazonaws.com/websitelogos/Niroggyan_logo.svg"
                  style={{ filter: "brightness(0) invert(1)", height: "32px", maxWidth: "140px", objectFit: "contain" }}
                />
              </Box>
            </Box>
            {/* hamburger icon */}
            {/* <Box sx={{ padding: "10px" }}>
              <IconButton onClick={() => setIsExpanded(!isExpanded)}>
                <MenuIcon />
              </IconButton>
            </Box> */}
            <Stack mt={0} gap={1}>
              {Object.keys(sideBarData).map((text, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  justifyContent={isExpanded ? "flex-start" : "center"}
                  gap={isExpanded ? 2 : 0}
                  onClick={() => {
                    handleNavigation(text);
                  }}
                  sx={{
                    minHeight: "46px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingRight: isExpanded ? "14px" : "8px",
                    paddingLeft: isExpanded ? "14px" : "8px",
                    borderRadius: "12px",
                    fontWeight: 500,
                    cursor: "pointer",
                    background: activeTab === text
                      ? "linear-gradient(90deg, rgba(70,126,255,0.38) 0%, rgba(44,33,149,0.58) 100%)"
                      : "transparent",
                    boxShadow: activeTab === text
                      ? "inset 0 0 0 1px rgba(112,190,255,0.42), 0 6px 14px rgba(10,8,58,0.35)"
                      : "none",
                    "&:hover": {
                      background: activeTab === text
                        ? "linear-gradient(90deg, rgba(70,126,255,0.46) 0%, rgba(44,33,149,0.64) 100%)"
                        : "rgba(255,255,255,0.09)",
                    },
                    transition: "all 0.18s ease",
                  }}
                >
                  <Tooltip title={isExpanded ? "" : text} placement="right">
                    <Box sx={{ color: "#fff", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", minWidth: 24 }}>
                      {sideBarData[text]}
                    </Box>
                  </Tooltip>
                  <Typography
                    variant="body2"
                    sx={{
                      flexGrow: "1",
                      color: "#fff",
                      fontSize: "13px",
                      display: isExpanded ? "" : "none",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "142px",
                    }}
                  >
                    {text}
                  </Typography>
                  {activeTab === text && isExpanded ? (
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: "#3CD0FF",
                        boxShadow: "0 0 0 4px rgba(60,208,255,0.2)",
                        flexShrink: 0,
                      }}
                    />
                  ) : null}

                  {loginDetails &&
                  loginDetails.role === "lab" &&
                  ((index === 1 &&
                    !loginDetails.showAnalytics &&
                    text === "Analytics") ||
                    (index === 2 &&
                      !loginDetails?.accessTo?.portal &&
                      text === "Manual Generation")) ? (
                    <Box
                      sx={{
                        textAlign: "center",
                        display: isExpanded ? "" : "none",
                      }}
                      px={1}
                    >
                      <LockIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)" }} />
                    </Box>
                  ) : (
                    ""
                  )}
                </Stack>
              ))}
            </Stack>
            {/* smart report tab */}
            {/* <Typography
          mt={1}
          variant="body2"
          sx={{ fontWeight: 700, padding: "12px 0px 12px 20px" }}
        >
          SMART REPORT
        </Typography>
        <Stack gap={1.5}>
          {Object.keys(manualEntryData).map((text) => (
            <Stack
              direction="row"
              alignItems="center"
              gap={2}
              onClick={() => handleNavigation(text)}
              sx={{
                padding: "10px 0px 10px 20px",
                borderRadius: "8px",
                fontWeight: 500,
                cursor: "pointer",
                background: activeTab === text ? "#CAE9F4" : "",
              }}
            >
              <Box>{manualEntryData[text]}</Box>
              <Typography variant="body2" sx={{ flexGrow: "1" }}>
                {text}
              </Typography>
              {loginDetails && !loginDetails?.accessTo?.portal ? (
                <Box sx={{ textAlign: "center" }} px={2}>
                  <LockIcon />
                </Box>
              ) : (
                ""
              )}
            </Stack>
          ))}
        </Stack> */}
            {/* smart report tab */}
            {/* account tab */}
            {/* <Typography
          mt={1}
          variant="body2"
          sx={{ fontWeight: 700, padding: "12px 0px 12px 20px" }}
        >
          ACCOUNT
        </Typography> */}
          </Box>
          {/* User identity and account action card */}
          {isExpanded && loginData && (
            <Box
              sx={{
                mt: 2,
                p: 1.5,
                background: "rgba(255,255,255,0.08)",
                borderRadius: "12px",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1.5}>
                <Stack direction="row" alignItems="center" gap={1.5} sx={{ minWidth: 0 }}>
                  <Box sx={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(135deg, rgba(60,208,255,0.65), rgba(53,103,214,0.85))", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <PersonIcon sx={{ color: "#fff", fontSize: 18 }} />
                  </Box>
                  <Box sx={{ overflow: "hidden" }}>
                    <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "140px" }}>
                      {loginData.displayName || loginData.org || "User"}
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "10px", textTransform: "capitalize" }}>
                      {loginData.role || ""}
                    </Typography>
                  </Box>
                </Stack>
                <Tooltip title="Logout" placement="top">
                  <IconButton
                    size="small"
                    onClick={logoutHandler}
                    sx={{
                      color: "#fff",
                      background: "rgba(255,255,255,0.08)",
                      border: "1px solid rgba(255,255,255,0.16)",
                      "&:hover": { background: "rgba(255,255,255,0.18)" },
                    }}
                  >
                    <LogoutIcon sx={{ fontSize: 17 }} />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Box>
          )}

          {loginData.role === "lab" ? dateStamp() : ""}

          {!isExpanded && (
            <Tooltip title="Logout" placement="right">
              <IconButton
                onClick={logoutHandler}
                sx={{
                  mt: 1.5,
                  color: "rgba(255,255,255,0.76)",
                  borderRadius: "10px",
                  "&:hover": { background: "rgba(255,255,255,0.08)", color: "#fff" },
                }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          )}

          <Box>{adminAndLisData()}</Box>
        </Stack>
        <Stack gap={2}>
          {loginData.role === "lab" ? (
            <Box
              sx={{
                zIndex: 999,
                padding: 0,
                position: "fixed",
                bottom: "80px",
                right: "16px",
                width: 48,
                height: 48,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #3567D6, #170C6B)",
                boxShadow: "0 4px 16px rgba(53,103,214,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": { transform: "scale(1.08)", boxShadow: "0 6px 20px rgba(53,103,214,0.6)" },
              }}
              onClick={() => setShowFeedback(true)}
            >
              <FeedbackIcon sx={{ color: "#fff", fontSize: 20 }} />
            </Box>
          ) : (
            ""
          )}
          <Box
            sx={{
              zIndex: 999,
              position: "fixed",
              bottom: "20px",
              right: "16px",
              width: 48,
              height: 48,
              borderRadius: "50%",
              background: "#fff",
              border: "1.5px solid #E8EEF8",
              boxShadow: "0 4px 12px rgba(0,0,0,0.10)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s ease",
              "&:hover": { background: "#f0f4ff", boxShadow: "0 4px 14px rgba(53,103,214,0.2)", borderColor: "#D0DEFF" },
            }}
            onClick={handleScroll}
          >
            <ArrowUpwardIcon sx={{ color: "#3567D6", fontSize: 20 }} />
          </Box>
        </Stack>
        <Feedback open={showFeedback} setOpen={setShowFeedback} />
      </Box>
    );
  };

  return newMenuBar();

  return (
    <>
      {/* Modal Start (for loading center data) */}
      <div>
        <>
          <Modal show={show} onHide={handleClose} backdrop="static" centered>
            <Modal.Body style={{ textAlign: "center" }}>
              <Spinner animation="border" size="sm" /> Loading Data ...
            </Modal.Body>
          </Modal>
        </>
      </div>

      {/* Modal End */}

      {/* Modal Start (for dynamic org and center) */}
      <div>
        <>
          <Modal show={show2} onHide={handleClose2}>
            <Modal.Header closeButton>
              <Modal.Title
                style={{ color: "#190e6c", display: "flex", gap: "12px" }}
              >
                <div>{"ORG & CENTER"}</div>

                <div>
                  <Dropdown style={{ position: "relative", top: "-3px" }}>
                    <Dropdown.Toggle
                      variant="info btn-sm"
                      id="dropdown-basic"
                      style={{ fontWeight: "bold" }}
                    >
                      New Client
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleNewClients("lab")}>
                        Add LAB
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNewClients("lis")}>
                        Add LIS
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNewClients("admin")}>
                        Add ADMIN
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* <button
                                    style={{ marginLeft: "10px", fontWeight: "bold", position: "relative", top: "-3px" }}
                                    className='btn btn-sm btn-info'
                                    onClick={() => window.open("/new-client/", "_self")}
                                >
                                    {"New"} <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                                </button> */}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body
              style={{ display: "flex", justifyContent: "space-around" }}
            >
              {/* Choose Org Dropdown Start */}
              <Dropdown>
                <Dropdown.Toggle
                  as={CustomToggle}
                  id="dropdown-custom-components"
                >
                  {"Choose Org "}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  as={CustomMenu}
                  style={{ overflow: "scroll", height: "300px" }}
                >
                  {orgAndCentersData.map((each, idx) => (
                    <Dropdown.Item
                      eventKey={idx}
                      onClick={() => chooseCenterHandler(each)}
                    >
                      {each.theOrg}
                    </Dropdown.Item>
                  ))}
                  {/* <Dropdown.Item eventKey="3" active>
                                        Orange
                                    </Dropdown.Item> */}
                </Dropdown.Menu>
              </Dropdown>

              {/* Choose Org Dropdown End*/}

              {/* Choose Center Dropdown Start */}
              {orgChoosen === "" ? (
                <span style={{ color: "grey" }}>{"Choose Center"}</span>
              ) : (
                <Dropdown>
                  <Dropdown.Toggle
                    as={CustomToggle}
                    id="dropdown-custom-components"
                  >
                    {"Choose Center "}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    as={CustomMenu2}
                    style={{ overflow: "scroll", height: "300px" }}
                  >
                    {selectionBasedCenters.map((each, idx) => (
                      <Dropdown.Item
                        eventKey={idx}
                        onClick={() => setCenterChoosen(each)}
                      >
                        {each}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {/* Choose Center Dropdown End */}
            </Modal.Body>

            <Modal.Body style={{ fontSize: "14px" }}>
              <span style={{ fontWeight: "550" }}>{"Org: "}</span>
              <span style={{ color: "#7787bc" }}>{orgChoosen}</span>
              {" | "}
              <span style={{ fontWeight: "550" }}>{"Center: "}</span>
              <span style={{ color: "#7787bc" }}>{centerChoosen}</span>
            </Modal.Body>
            <Modal.Footer
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <a href="/subscription">
                <Button
                  disabled
                  onClick={() =>
                    localStorage.setItem(
                      "choosenClient",
                      JSON.stringify({ org: orgChoosen, center: centerChoosen })
                    )
                  }
                  variant="outline-success btn-sm d-none"
                >
                  {"Edit Subscription"}
                </Button>
              </a>

              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="info btn-sm"
                  onClick={customOrgAndCenterApiHandler}
                >
                  Fetch Info
                </Button>
                <Button variant="primary btn-sm" onClick={handleClose2}>
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        </>
      </div>

      {/* Modal End */}

      <Navbar
        className="navbarMainCss shadow-sm mb-5 bg-white rounded"
        expand="true"
      >
        <Container fluid>
          <Navbar.Brand href="/new-billing-dashboard">
            {/* <img className="navLogoCss" src={imageToUse === undefined ? defaultImage : imageToUse} alt="logo" /> */}
            <img className="navLogoCss" src={logoToUse} alt="logo" />
          </Navbar.Brand>
          {loginData ? (
            <>
              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <Nav className="me-auto my-2 my-lg-0" navbarScroll />
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingTop: "10px",
                  }}
                  className="d-flex"
                >
                  {/* <UserSvg /> */}
                  <div
                    className="mx-3"
                    style={{
                      display:
                        loginData && loginData.role === "LIS" ? "" : "none",
                    }}
                  >
                    {/* <DownloadSvg /> */}
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="dropdownCss"
                        id="dropdown-basic"
                        style={{
                          backgroundColor: "#ecedef",
                          borderRadius: "20px",
                        }}
                      >
                        {"Choose Clients"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ textAlign: "center" }}>
                        {loginData && loginData.role === "LIS"
                          ? loginData.liveClients.map((each, idx) => (
                              <Dropdown.Item
                                key={idx}
                                onClick={() => getCenterData(each)}
                              >
                                <span>{each}</span>
                              </Dropdown.Item>
                            ))
                          : ""}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div
                    className="align-item-center"
                    style={{
                      marginTop: "0px",
                      marginRight: "16px",
                      display:
                        loginData && loginData.role === "admin"
                          ? "flex"
                          : "none",
                      alignItems: "center",
                    }}
                  >
                    {/* <DownloadSvg /> */}
                    <a href="/client-data">
                      <Button variant="outline-primary btn-sm mx-2">
                        {"Edit Subscription"}
                      </Button>
                    </a>
                    <div
                      onClick={handleShow2}
                      className="dropdownCss"
                      id="dropdown-basic"
                      style={{
                        position: "relative",
                        // top: '8px',
                        cursor: "pointer",
                        backgroundColor: "#ecedef",
                        // borderRadius: "20px",
                        // padding: "10px",
                      }}
                    >
                      {"Choose Org & Center"}
                    </div>
                  </div>
                  <div style={{ marginTop: "0px" }} title="logout">
                    <LogoutComponent />
                  </div>
                </div>
              </Navbar.Collapse>
            </>
          ) : (
            ""
          )}
          {/* {maintenance ? (
            <div title='logout'>
              <LogoutComponent />
            </div>
          ) : (
            ''
          )} */}
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComponent;
